import { render } from "./user.vue?vue&type=template&id=72be5240&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=72be5240&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-72be5240"

export default script